import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import Hero from "./components/Hero";
import GenreSection from "./components/GenreSection";
import HotRanking from "./components/HotRanking";
import { LatestGrid, TopRatedGrid } from "./components/ComicGrid";
import FeaturedSection from "./components/FeaturedSection";
import FaqSection from "./components/FaqSection";

export default function Home() {
  return (
    <div id="top" className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <GenreSection />
        <HotRanking />
        <FeaturedSection />
        <LatestGrid />
        <TopRatedGrid />
        <FaqSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}